var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button } from 'ui/styled';
import usePlanChangeHandlingDeleteAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/PLAN_CHANGE_HANDLING_DELETE_ATTACHMENT';
import usePlanChangeHandlingUpdateAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/PLAN_CHANGE_HANDLING_UPDATE_ATTACHMENT';
import useAccumulatorChangeUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/ACCUMULATOR_CHANGE_UPLOAD_ATTACHMENT';
import useFertilityMaximumUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/FERTILITY_MAXIMUM_UPLOAD_ATTACHMENT';
import useGroupNumberChangeUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/GROUP_NUMBER_CHANGE_UPLOAD_ATTACHMENT';
import usePlanChangeHandlingUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/PLAN_CHANGE_HANDLING_UPLOAD_ATTACHMENT';
import { ACCUMULATOR_CHANGE_ATTACHMENT_OPTIONS, FERTILITY_MAXIMUM_ATTACHMENT_OPTIONS, GROUP_NUMBER_CHANGE_ATTACHMENT_OPTIONS, PLAN_CHANGE_HANDLING_ATTACHMENT_OPTIONS } from 'constants/planChangeHandlingConstants';
import Attachments from 'pages/Ticket/components/RequestData/components/Attachments';
import NewAttachment from '../components/NewAttachment';
var PlanChangeHandlingFieldsAttachment = function (_a) {
    var resource = _a.resource, form = _a.form, sourceType = _a.sourceType;
    var _b = useState([]), attachments = _b[0], setAttachments = _b[1];
    var onPlanChangeHandlingDeleteAttachment = usePlanChangeHandlingDeleteAttachment().onPlanChangeHandlingDeleteAttachment;
    var onPlanChangeHandlingUpdateAttachment = usePlanChangeHandlingUpdateAttachment().onPlanChangeHandlingUpdateAttachment;
    var onAccumulatorChangeUploadAttachment = useAccumulatorChangeUploadAttachment().onAccumulatorChangeUploadAttachment;
    var onFertilityMaximumUploadAttachment = useFertilityMaximumUploadAttachment().onFertilityMaximumUploadAttachment;
    var onGroupNumberChangeUploadAttachment = useGroupNumberChangeUploadAttachment().onGroupNumberChangeUploadAttachment;
    var onPlanChangeHandlingUploadAttachment = usePlanChangeHandlingUploadAttachment().onPlanChangeHandlingUploadAttachment;
    var getUploadHandler = function () {
        var handlers = {
            accumulator_change: onAccumulatorChangeUploadAttachment,
            fertility_maximum: onFertilityMaximumUploadAttachment,
            group_number_change: onGroupNumberChangeUploadAttachment,
            plan_change_handling: onPlanChangeHandlingUploadAttachment
        };
        return handlers[sourceType];
    };
    var getAttachmentTypeOptions = function () {
        var options = {
            accumulator_change: ACCUMULATOR_CHANGE_ATTACHMENT_OPTIONS,
            fertility_maximum: FERTILITY_MAXIMUM_ATTACHMENT_OPTIONS,
            group_number_change: GROUP_NUMBER_CHANGE_ATTACHMENT_OPTIONS,
            plan_change_handling: PLAN_CHANGE_HANDLING_ATTACHMENT_OPTIONS
        };
        return options[sourceType];
    };
    var onAddAttachment = function () {
        setAttachments(__spreadArray(__spreadArray([], attachments, true), [attachments.length], false));
        var attachmentsField = form.getFieldValue('attachments');
        if (!attachmentsField)
            form.setFieldsValue({ attachments: [] });
    };
    var onRemoveAttachment = function (index) {
        var newArray = __spreadArray([], attachments, true);
        newArray.pop();
        var newAttachments = form.getFieldValue('attachments');
        if (!newAttachments)
            return false;
        newAttachments = newAttachments.filter(function (_, i) { return i !== index; });
        form.setFieldsValue({ attachments: newAttachments });
        setAttachments(newArray);
    };
    var attachToForm = function (file, index) { return __awaiter(void 0, void 0, void 0, function () {
        var uploadHandler, isErrorFree;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!resource)
                        return [2 /*return*/, false];
                    uploadHandler = getUploadHandler();
                    return [4 /*yield*/, uploadHandler({
                            source_id: resource === null || resource === void 0 ? void 0 : resource.id,
                            attachments: [
                                {
                                    file: file,
                                    title: form.getFieldValue(['attachments', index, 'title']),
                                    notes: form.getFieldValue(['attachments', index, 'notes'])
                                }
                            ]
                        })];
                case 1:
                    isErrorFree = (_a.sent()).isErrorFree;
                    if (!isErrorFree)
                        return [2 /*return*/, false];
                    onRemoveAttachment(index);
                    return [2 /*return*/];
            }
        });
    }); };
    var attachUpdateHandler = function (currentAttachments) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!currentAttachments || !currentAttachments.length)
                        return [2 /*return*/, false];
                    return [4 /*yield*/, onPlanChangeHandlingUpdateAttachment({
                            id: currentAttachments[0].id,
                            attachment: {
                                notes: currentAttachments[0].notes,
                                title: currentAttachments[0].title
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var attachRemoveHandler = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onPlanChangeHandlingDeleteAttachment({ id: id })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [(resource === null || resource === void 0 ? void 0 : resource.source_attachments) && (_jsx(Attachments, { attachments: resource === null || resource === void 0 ? void 0 : resource.source_attachments, updateHandler: attachUpdateHandler, removeHandler: attachRemoveHandler, attachmentOptions: getAttachmentTypeOptions() })), attachments.map(function (index) { return (_jsx(NewAttachment, { index: index, attachHandler: attachToForm, onRemoveAttachment: onRemoveAttachment, attachmentOptions: getAttachmentTypeOptions() }, index)); }), _jsx(Button, { onClick: onAddAttachment, "data-test": "ticketAddAttachmentBtn", children: "Add New Attachment" })] }));
};
export default PlanChangeHandlingFieldsAttachment;
